import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    PlannedConsultationPopUpDelete: {
        marginTop: '-1.2rem',
        marginBottom: '1.2rem',
        textAlign: 'left',
        alignSelf: 'flex-start',
    },
    PlannedConsultationPopUpDeleteBackdrop: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        backgroundColor: theme.palette.consultation.black + '!important',
    },
}))

